import React, { createContext, useContext, useState, useEffect } from 'react';

const UnreadCountContext = createContext();

export const useUnreadCount = () => {
  const context = useContext(UnreadCountContext);
  if (!context) {
    return { totalUnreadCount: 0, setTotalUnreadCount: () => {} };
  }
  return context;
};

export const UnreadCountProvider = ({ children }) => {
  const [totalUnreadCount, setTotalUnreadCount] = useState(() => {
    // Load from localStorage on initialization
    const savedCount = localStorage.getItem('totalUnreadCount');
    return savedCount ? parseInt(savedCount, 10) : 0;
  });

  // Listen for localStorage changes (in case updated from another tab/component)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'totalUnreadCount') {
        setTotalUnreadCount(e.newValue ? parseInt(e.newValue, 10) : 0);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <UnreadCountContext.Provider value={{ totalUnreadCount, setTotalUnreadCount }}>
      {children}
    </UnreadCountContext.Provider>
  );
};

